import { render, staticRenderFns } from "./XhReceivablesPlan.vue?vue&type=template&id=76a946c6&scoped=true&"
import script from "./XhReceivablesPlan.vue?vue&type=script&lang=js&"
export * from "./XhReceivablesPlan.vue?vue&type=script&lang=js&"
import style0 from "./XhReceivablesPlan.vue?vue&type=style&index=0&id=76a946c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a946c6",
  null
  
)

component.options.__file = "XhReceivablesPlan.vue"
export default component.exports